import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import {Button} from "@mui/material";
import {useRef, useState} from "react";
import {CheckCircle} from "@mui/icons-material";
import Box from "@mui/material/Box";
import QuotationItemList from "./QuotationItemList";
import ClientContact from "./ClientContact";
import useInterventionRepository from "../../../../../../repository/insurance/useInterventionRepository";
import Intervention from "../../../../../../entity/insurance/Intervention";
import useAlert from "../../../../../../use/useAlert";
import parameter from "../../../../../../enum/parameter";

const ERROR_ITEM_REQUIRED = "Ajoutez au moins un item au devis.";

export default function ({interventionId, orderId, clientId}) {
    const alert = useAlert();
    const interventionRepository = useInterventionRepository();
    const quotationPayload = useRef({vat: 10});
    const quotationItemPayload = useRef([]);
    const clientPhoneMobileInput = useRef(null);
    const clientEmailInput = useRef(null);
    const [loading, setLoading] = useState(false);

    const handleQuotationPayloadChange = data => quotationPayload.current = data;
    const handleQuotationItemPayloadChange = data => quotationItemPayload.current = data;
    const handleClientPhoneMobileChange = data => clientPhoneMobileInput.current = data;
    const handleClientEmailChange = data => clientEmailInput.current = data;

    const nextStep = async () => {
        setLoading(true);

        if (quotationItemPayload.current.length === 0) {
            alert.warning(ERROR_ITEM_REQUIRED);
            setLoading(false);
            return;
        }

        const res = await interventionRepository.updateCurrentStep(interventionId, {
            intervention: {
                current_step: Intervention.STEP_QUOTATION
            },
            quotation: quotationPayload.current,
            quotation_item: quotationItemPayload.current,
            client: {
                phone_mobile: clientPhoneMobileInput.current,
                email: clientEmailInput.current
            }
        });

        if (!res) setLoading(false);
    }

    return (
        <>
            <Body sx={{pt: 1, pb: 2}}>
                <Box px={1}>
                    <QuotationItemList
                        orderId={orderId}
                        onQuotationPayloadChange={handleQuotationPayloadChange}
                        onQuotationItemPayloadChange={handleQuotationItemPayloadChange}
                    />
                </Box>
                <Box mt={5} px={1}>
                    <ClientContact
                        clientId={clientId}
                        onPhoneMobileChange={handleClientPhoneMobileChange}
                        onEmailChange={handleClientEmailChange}
                    />
                </Box>
            </Body>
            <Footer>
                <Button
                    variant="contained"
                    size="small"
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    fullWidth
                    onClick={nextStep}
                    disabled={loading}
                    data-test="insurance-button-next-step"
                >
                    Valider le devis
                </Button>
            </Footer>
        </>
    );
}
